import { Box, HStack } from '@chakra-ui/react';
import { navigate } from '@reach/router';
import React, { useCallback, useEffect, useState } from 'react';
import AddBuisinessForm from '../add-buisiness-form';
import WelcomeUserForm from '../welcome-user-form';

const RADIUS = 36;
const Steps = ({ currentStep }) => (
  <HStack>
    {['1'].map((step, index) => (
      <Box
        bg={currentStep === index ? 'brand.red' : 'white'}
        color={currentStep === index ? 'white' : 'brand.red'}
        borderColor="brand.red"
        borderWidth={1}
        borderStyle="solid"
        py="1"
        textAlign="center"
        key={step}
        w={RADIUS + 'px'}
        h={RADIUS + 'px'}
        rounded="full"
      >
        {step}
      </Box>
    ))}
  </HStack>
);

const MerchantOnboardingForm = ({ backToLogin, step }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const nextStep = useCallback(() => {
    setCurrentStep((o) => o + 1);
  }, [setCurrentStep]);
  useEffect(() => {
    if (step) {
      setCurrentStep(step);
    }
  }, [step, setCurrentStep]);
  return (
    <Box px={4}>
      <Steps {...{ currentStep }} />
      {currentStep === 0 ? (
        <WelcomeUserForm {...{ nextStep, backToLogin }} />
      ) : currentStep === 1 ? (
        <AddBuisinessForm
          {...{ backToLogin }}
          nextStep={async () => {
            navigate('/');
          }}
        />
      ) : null}
    </Box>
  );
};

export default MerchantOnboardingForm;
